import { FE_ENABLE_HOTJAR_SESSION_RECORDING_251001 } from "@faire/web-settings/FE_ENABLE_HOTJAR_SESSION_RECORDING_251001";

import { getSettingValueWithoutAssignment } from "./__internal__/getSetting";

export const getSettingHotjarRecordingEnabled = (): boolean =>
  getSettingValueWithoutAssignment(
    FE_ENABLE_HOTJAR_SESSION_RECORDING_251001,
    false
  );
